module.exports = __webpack_public_path__ + "img/0c7344af287eed724bcb140ca0f7f836.png";